import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class HubspotCtaController extends Controller {
  static targets = ["successMessage", "errorMessage"];
  static values = { facilityId: String };

  declare readonly successMessageTarget: HTMLElement;
  declare readonly errorMessageTarget: HTMLElement;
  declare readonly hasSuccessMessageTarget: boolean;
  declare readonly hasErrorMessageTarget: boolean;
  declare readonly facilityIdValue: string;

  async submit(event: Event) {
    const button = event.currentTarget as HTMLButtonElement;
    const nextStep = button.dataset.nextStep;

    this.setButtonsDisabled(true);

    try {
      const response = await post(
        `/facilities/${this.facilityIdValue}/climate_risk_assessments/submit_hubspot_cta`,
        {
          body: JSON.stringify({ next_step: nextStep }),
          contentType: "application/json",
          responseKind: "json",
        }
      );

      if (response.ok) {
        this.showTarget("successMessage");
      } else {
        this.showTarget("errorMessage");
      }
    } catch {
      this.showTarget("errorMessage");
    } finally {
      this.setButtonsDisabled(false);
    }
  }

  private setButtonsDisabled(disabled: boolean) {
    this.element
      .querySelectorAll<HTMLButtonElement>("button[data-action]")
      .forEach((btn) => (btn.disabled = disabled));
  }

  private showTarget(targetName: "successMessage" | "errorMessage") {
    if (targetName === "successMessage" && this.hasSuccessMessageTarget) {
      this.successMessageTarget.hidden = false;
    }
    if (targetName === "errorMessage" && this.hasErrorMessageTarget) {
      this.errorMessageTarget.hidden = false;
    }
  }
}
